export default class ImageOverlay {
  constructor() {
    this.wrapper = document.querySelector('.profile-wrapper');
    if (this.wrapper) {
      this.wrapper.addEventListener('click', this.overlay.bind(this));
    }
  }

  overlay() {
    document.querySelector('#avatar').classList.toggle('active');
    document.querySelector('.avatar-overlay').classList.toggle('active');
  }
}
